import * as React from "react"
const Atronaut = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    transform="rotate(-45)"
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      fill="#1d1d1b"
      d="M12.11 9.68c.82.08 3.34 3.08 4.46 4.2s1.38 2 2.67 2.5 1.41.55 1.5.38a12.33 12.33 0 0 0 .26-1.29s-1.46-.38-1.67-.92 3-9 3.63-9.33 1.45 0 1.33.33-3.92 8.25-3.67 8.54a2.86 2.86 0 0 0 .79.54s.67-1 1-1a3.66 3.66 0 0 1 1.17.59s.29-.8.79-.67a2.63 2.63 0 0 1 1 .75s.13-.54.55-.33 3.16 1.75 3.16 1.75a10 10 0 0 1 2.57-9.92c4.42-4.33 9-3.92 14-1s4.13 7.92 4.09 10-2 4.87-4.25 6.54S42.32 23 42.32 23s3.42 1 3.38 1.62a14.74 14.74 0 0 1-1.3 2.84 13.45 13.45 0 0 0 4.09 2.75c2.83 1.33 7.58 2.25 8.62 3.41a5.63 5.63 0 0 1 .38 6.17c-1.29 2.58-3.21 2.88-6.42 1.5s-4.29-2.58-6-3.08A17.12 17.12 0 0 1 42 37.13c-.75-.37-1.21-1.79-1.75-1.33a39.43 39.43 0 0 0-4 6.54A76.88 76.88 0 0 0 32.57 50c-.46 1.33-2.62 6.79-3.67 8.21s-2 3.16-2.91 3.25-5.29-1.88-6-2.34-2-1.33-1.54-2.5 4.16-8.36 5.08-10.62 1.42-3 1.12-3.29-2-.55-2.25 0S18 52.68 17 54.38s-3.34 2-5.67 1-4.21-2.91-4.46-3.66a3.33 3.33 0 0 1 0-2.29c.29-.71 3.54-5.92 4.13-7.34a18.31 18.31 0 0 1 2.12-3.87c.71-.92 3.13-5.59 4.84-8.59s2-4.16 1.7-4.33A13.5 13.5 0 0 0 16 24.18c-1 0-3 .16-3.59-.34a79.39 79.39 0 0 1-4.62-7c-1.25-2-2.29-2.83-1.92-3.91a5.7 5.7 0 0 1 3-2.75 6.59 6.59 0 0 1 3.24-.5z"
    />
    <path
      fill="#85bfe9"
      d="M11.53 11.76a2.78 2.78 0 0 1 1.37 1c.46.58 1.71 2 1.34 2.25s-2.09 1.29-2.71 1.79-.71 1.13-1 .84-2.5-3.8-2.42-4.38 1.13-1.88 3.42-1.5z"
    />
    <path
      fill="#cbe7f5"
      d="M14.82 16c.23 0 1.71 1.92 4.25 2.62a28.38 28.38 0 0 0 6.71 1.42c2 0 4.67-.21 5-.08s0 1.37 3.5 2.54a21.44 21.44 0 0 0 5.5 1c.17.17 2.17 4.71 3.38 5.92s7 3.41 6.79 3.79a35 35 0 0 0-1.29 3.46c-.13.5 0 .79-.38.7s-3.79-1.45-4.25-1.66-.79-.09-1.33-.75-1.5-2.54-2.17-2.59a1.39 1.39 0 0 0-1.33.63c-.21.37-2.8 4.08-3.59 5.54s-2.66 6.25-3.16 7-.71 1.71-.92 1.58a32.79 32.79 0 0 0-3-1.87c-.37-.09-2.17-.54-2.08-.75s1.33-2.42.54-3a17.75 17.75 0 0 0-4.42-1.38c-.5-.12-1.87 2.18-1.87 2.18a34.93 34.93 0 0 0-3.17-2.17c-1-.54-2.71-.87-2.63-1.16s4.34-8 5.42-9.84 2.42-4.29 1.46-4.79a27.66 27.66 0 0 0-5.38-1.58 5.23 5.23 0 0 1-2.25-.17c-.45-.29-3-3.5-2.79-4.08A11.11 11.11 0 0 1 14.82 16z"
    />
    <path
      fill="#f2910d"
      d="M22.49 14.84c.3 0 .46 0 .37.46s-.37 2-.54 1.92-.71-.09-.62-.25a16.21 16.21 0 0 1 .79-2.13zM24.4 14.76s.71.17.63.33-.5 2.42-.71 2.38-.5 0-.54-.17.62-2.54.62-2.54z"
    />
    <path
      fill="#e7413e"
      d="M26.11 15.47c.27-.21 2.92 1.16 3.17 1.46s.62.83.42.87-2.13.08-2.84.13-1.46 0-1.41-.17a10.72 10.72 0 0 1 .66-2.29z"
    />
    <path
      fill="#85bfe9"
      d="M37.61 4.84c2.86-.54 5.92.79 8.29 2.5s2.8 5.5 1.84 8.29-3.54 5.5-6.74 5.75-6-.29-8.34-2.7S31 11.13 32 9.13a7.82 7.82 0 0 1 5.61-4.29z"
    />
    <path
      fill="#1d1d1b"
      d="M35.45 7.22a32.21 32.21 0 0 0 6.7 3.41c3.71 1.34 5.21 1.75 5.17 2.3S47 18 43.4 19.72a8.72 8.72 0 0 1-9.7-1.42c-2.42-2.17-2.05-5.37-.92-7.79s2.46-3.42 2.67-3.29z"
    />
    <path
      fill="#1f4863"
      d="M36 9.8c.44.1 2.79 1.38 5.37 2.5s4 1.33 3.92 1.83a7 7 0 0 1-2.59 3.71c-1.58 1-3.54 1.25-6-.25s-2.58-3-2.29-4.62S35.57 9.72 36 9.8z"
    />
    <path
      fill="#1d1d1b"
      d="M40.11 13c.5.33 1.71 1.83 1.42 2.12s-.17.67-.67.46a5 5 0 0 1-1.66-2.12c.08-.28.91-.46.91-.46zM37.74 13.88c.12-.05 2.25 2.67 2 3s-.79.63-.92.54-2.16-2.75-2-3 .58-.37.92-.54z"
    />
    <path
      fill="#e7413e"
      d="M42.45 24c-.16-.16 1.87.54 1.79.92s0 1.29-.42 1.12-1.29-1.95-1.37-2.04z"
    />
    <path
      fill="#85bfe9"
      d="M51.24 33.72c.17-.08 3.91 1 4.5 1.75s.29 2.5-.25 3.46S54.7 40 54.07 40a17 17 0 0 1-4.21-1.83c-.25-.29 1-4.29 1.38-4.45z"
    />
    <path
      fill="#1d1d1b"
      d="M27.07 23.13c.32-.2 9.54 4.21 9.42 4.92s-3 7.54-4 7.88-8.75-3.5-9-4.25 3.12-8.25 3.58-8.55z"
    />
    <path
      fill="#e7413e"
      d="M27.57 24.68c.2-.08 7.63 3.33 7.54 3.7s-3 6.17-3.16 6.17S25 31.34 25 31s2.24-6.2 2.57-6.32z"
    />
    <g fill="#1d1d1b">
      <path d="M31.05 28c.31-.63 1.22-.87 2.3 0s-.63 2.83-1.85 2-.63-1.61-.45-2zM30 31.14c.26-.52 1-.72 1.91 0s-.52 2.35-1.54 1.62-.52-1.33-.37-1.62zM35 35.63s.71 1 .5 1.38-.33.67-.54.5a2.26 2.26 0 0 1-.59-1.17c.08-.25.63-.71.63-.71zM32.9 36.93c.17.12 1.25 1.87 1 2.29s-.25.5-.45.5A6.56 6.56 0 0 1 32 37.51c0-.21.9-.58.9-.58zM31.32 38.13c.25.09 1.83 2.34 1.71 2.71a2.39 2.39 0 0 1-.5.75s-2.21-2.66-2-2.91a2.66 2.66 0 0 1 .79-.55zM29.86 39.3s2.21 2.88 2 3.33 0 .55-.41.46-2.59-2.79-2.38-3.09a4.7 4.7 0 0 1 .79-.7z" />
    </g>
    <path
      fill="#85bfe9"
      d="M14.4 39.93c.14-.17 1.38.75 1.92 1.12a2.39 2.39 0 0 0 1.21.63 2.33 2.33 0 0 1 1.21.62c.37.29 1.46.71 1.33.92s-1.5 3.91-1.79 4.54-.67 1.29-.67 1.29-.12.25-.5-.25-1.11-1.37-1.46-1.37-.91.5-1.37.16-1.17-2.08-1.67-2.21-.87.13-.87-.16a52.35 52.35 0 0 1 2.66-5.29zM26.24 45.63a6.93 6.93 0 0 1 2.12.8c.88.45 1 1 1.71 1.33s1.08.21 1.08.54-1.5 4.25-1.83 4.29a5 5 0 0 1-2.25-.46c-.42-.33-.79-1.16-1.37-1.08a4.68 4.68 0 0 1-1.5 0c-.42-.08-.75-.12-.63-.54s2.29-4.79 2.67-4.88z"
    />
    <path
      fill="#1d1d1b"
      d="M27.24 47.51c.38 0 .46.37 1 .46s.79.16.7.41-.12.67-.33.55a2.4 2.4 0 0 0-.87-.46c-.34 0-.75-.09-.8-.25a1.11 1.11 0 0 1 .3-.71zM25.74 49.26c.33 0 .46.46 1 .62s.91.09.83.46 0 .67-.29.59-.75-.46-1.17-.55-.66.09-.79-.29a.79.79 0 0 1 .42-.83zM16.61 42.43c.21 0 0 .29.59.5s.91.29.83.5-.17.45-.42.45a3.87 3.87 0 0 1-1-.37c-.42-.17-.5-.21-.5-.38a1.64 1.64 0 0 1 .5-.7zM14 43.38c.27-.26.58.88 1.25 1.09s1 .25 1.08.46.17.62-.12.7a1.25 1.25 0 0 1-1.13-.29c-.46-.33-.79-.87-1.21-1s-.58 0-.54-.2.57-.63.67-.76z"
    />
    <path
      fill="#cbe7f5"
      d="M11.28 46.22c.18-.18 1.08-.25 1.25.21s.21 2.12 1.08 2.37 1.17-.58 1.71-.17.67.92 1 1 .75.12.71.29-1.62 3.12-2.33 3.58-1.38.5-3.21-.46S8.86 51.51 9 50.55s2-4.04 2.28-4.33zM23 51.63c.27-.26.25.75 1 .8s1.08-.17 1.63 0 .66.91 1.54 1.08 1.62.33 1.58.5-2.75 5.25-3.08 5.21A34.19 34.19 0 0 1 22.24 58c-1-.42-1.38-.92-1.29-1.29A44.9 44.9 0 0 1 23 51.63z"
    />
  </svg>
)
export default Atronaut
